import React from "react";
import useGuideMediaManifestVersion from "../../hooks/useGuideMediaManifestVersion";
import { resolveGuideAssetUrl } from "../../utils/resolveGuideAssetUrl";

export default function GuideImage({ src, alt = "", ...props }) {
  useGuideMediaManifestVersion();
  return <img {...props} alt={alt} src={resolveGuideAssetUrl(src)} />;
}
